import {UserState} from "../states/userState.state";
import {createFeatureSelector, createSelector} from "@ngrx/store";

export const selectUserState = createFeatureSelector<UserState>('user');
export const selectConnectedUser = createSelector(selectUserState, userState => userState?.connectedUser);
export const selectIsPartnerAdmin = createSelector(selectUserState, userState => userState?.isPartnerAdmin);
export const selectIsMandataire = createSelector(selectUserState, userState => userState?.isMandataire);
export const selectIsAcepPartner = createSelector(selectUserState, userState => userState?.isAcepPartner);
export const selectUserPartner = createSelector(selectUserState, userState => userState?.userPartner);
export const selectUserCustomer = createSelector(selectUserState, userState => userState?.userCustomer);
export const selectUserPreferences = createSelector(selectUserState, userState => userState?.userPreferences);
